export default "__VITE_ASSET__DVhM81VW__"